import { i18nFunct } from '@lucid/gatsby-theme-lucid';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useContext, useEffect } from 'react';

import LayoutContext from '../../contexts/layoutContext';
import Link from '../link/link';
import './clients.scss';

interface Logo {
  node: {
    alt: string;
    src: string;
    show: boolean;
  };
}

const i18nLinks: { [key: string]: string } = {
  en: '/pages/case-studies',
  fr: '/pages/fr/clients',
  ja: '/pages/ja/customers',
  de: '/pages/de/kunden',
  pt: '/pages/pt/clientes',
  es: '/pages/es/clientes'
};

function getRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const Clients = () => {
  useEffect(() => {
    let lastLogoPosition: string | null;
    const interval = setInterval(() => {
      const shownLogos: HTMLImageElement[] = Array.from(
        document.querySelectorAll('.clients__customer-logo--shown')
      );
      const logoToRemoveIndex = getRandomInt(0, shownLogos.length - 2);
      let logoToRemove = shownLogos[logoToRemoveIndex];

      let { logoPosition } = logoToRemove.dataset;
      if (logoPosition === lastLogoPosition) {
        logoToRemove = shownLogos[shownLogos.length - 1];
        logoPosition = shownLogos.length.toString();
      }
      lastLogoPosition = logoPosition || null;

      const hiddenLogos: HTMLImageElement[] = Array.from(
        document.querySelectorAll('.clients__customer-logo--hidden')
      );
      const logoToAdd = hiddenLogos[getRandomInt(0, hiddenLogos.length - 1)];

      logoToRemove.classList.remove('clients__customer-logo--shown');
      setTimeout(() => {
        logoToRemove.classList.add('clients__customer-logo--hidden');
        logoToAdd.dataset.logoPosition = logoToRemove.dataset.logoPosition;
        logoToRemove.dataset.logoPosition = undefined;
        logoToAdd.classList.remove('clients__customer-logo--hidden');
        logoToAdd.classList.add('clients__customer-logo--shown');
      }, 1000);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  });

  const {
    language: { i18nKey, langPrefix }
  } = useContext(LayoutContext);

  const {
    i18nData,
    allClientsJson: { edges }
  } = useStaticQuery(
    graphql`
      {
        allClientsJson {
          edges {
            node {
              src
              alt
              show
              position
            }
          }
        }
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_social_proof_number
                mktg_clients_find_out_why
              }
            }
          }
        }
      }
    `
  );

  const logos: Logo[] = edges;
  const i18n = i18nFunct(i18nData, i18nKey);

  return (
    <aside className="clients">
      <p
        className="clients__blurb"
        dangerouslySetInnerHTML={{
          __html: i18n('mktg-social-proof-number', {}, [
            '<span class="clients__top">{}</span><br class="clients__spacer" />',
            '{}'
          ])
        }}
      />
      <Link
        asButton
        excludeFromGatsby
        secondary
        to={i18nLinks[langPrefix] || i18nLinks.en}
      >
        {i18n('mktg-clients-find-out-why')}
      </Link>
      <div className="clients__social-proofs">
        {logos.map((logo: Logo, i) => (
          <img
            key={logo.node.alt}
            src={logo.node.src}
            alt={logo.node.alt}
            className={`clients__customer-logo ${
              logo.node.show
                ? 'clients__customer-logo--shown'
                : 'clients__customer-logo--hidden'
            }`}
            data-logo-position={i <= 2 ? i + 1 : null}
          />
        ))}
      </div>
    </aside>
  );
};

export default Clients;
